<template>
		<!-- Main content -->
		<div class="content-wrapper">

			<!-- Page header -->
			<app-breadcrumb/>
			<!-- /page header -->

			<!-- Content area -->
			<div class="content">
				
				<!-- Simple panel -->
				<div class="panel panel-flat border-top-lg border-top-success">
					<div class="panel-heading">
                      	<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalAddMovie" title="Add new movie">
	                        <span>
	                          <i class="icon-plus22"></i>
	                          <span>Add new movie</span>
	                        </span>
                      	</button>
						<!-- begin:Form Search Sub -->
<!-- 						<form id="formSearchSub" class="pull-right mr-5">
							<button type="submit" data-style="zoom-out" class="btn btn-success" title="Search for empty subtitles"><i class="icon-search4 position-left"></i> Search for empty subtitles</button>
						</form> -->
						<!-- end:Form Search Sub -->


						<div class="pull-right">
							<div class="row">
								
								<div class="col-md-4">
									<form class="form-check form-check-inline text-center" id="formMovieEmbedID">
										<label class="form-check-label pure-material-checkbox">
											<input v-if="movie_settings.embed_id_status == 1" onChange="$('#formMovieEmbedID').submit();" name="embed_id_status" type="checkbox" class="form-check-input-styled-success" checked>
											<input v-else onChange="$('#formMovieEmbedID').submit(); return false;" name="embed_id_status" type="checkbox" class="form-check-input-styled-success">
											<input type="hidden" name="id" :value="movie_settings.id">
										</label>
										<label class="label label-success btn-block">ID</label>
									</form>
								</div>

								<div class="col-md-4">
									<form class="form-check form-check-inline text-center" id="formMovieIMDbID">
										<label class="form-check-label">
											<input v-if="movie_settings.imdb_id_status == 1" onChange="$('#formMovieIMDbID').submit();" name="imdb_id_status" type="checkbox" class="form-check-input-styled-success" checked>
											<input v-else onChange="$('#formMovieIMDbID').submit(); return false;" name="imdb_id_status" type="checkbox" class="form-check-input-styled-success">
											<input type="hidden" name="id" :value="movie_settings.id">
										</label>
										<label class="label label-success btn-block">IMDb</label>
									</form>
								</div>

								<div class="col-md-4">
									<form class="form-check form-check-inline text-center" id="formMovieTMDbID">
										<label class="form-check-label">
											<input v-if="movie_settings.tmdb_id_status == 1" onChange="$('#formMovieTMDbID').submit();" name="tmdb_id_status" type="checkbox" class="form-check-input-styled-success" checked>
											<input v-else onChange="$('#formMovieTMDbID').submit(); return false;" name="tmdb_id_status" type="checkbox" class="form-check-input-styled-success">
											<input type="hidden" name="id" :value="movie_settings.id">
										</label>
										<label class="label label-success btn-block">TMDb</label>
									</form>
								</div>

							</div>
						</div>


					</div>

					<div class="panel-body">
				
						<!-- begin::Well White -->
						<div class="well well-white">
							<!-- begin:Form Search -->
							<form class="row" id="formSearchDataMovie">
								  <div class="form-group">
								      <div class="col-sm-10">
								          <input type="search" name="searchQuery" class="form-control" placeholder="Enter movie name...">
								      </div>
								      <div class="col-sm-2">
								      	<button type="submit" data-style="zoom-out" class="btn btn-success btn-block" title="Search"><i class="icon-search4 position-left"></i> Search</button>
								      </div>
								  </div>
							</form>
							<!-- end:Form Search -->
						</div>
						<!-- end::Well White-->

						<!-- begin:Table Responsive-->
						<div class="table-responsive pt-10">
		                  <table class="table table-bordered table-hover" v-if="movies != ''">
		                      <thead>
		                        <tr class="active">
		                            <th>Movie name</th>
		                            <th>Year</th>
		                            <th>Embed link</th>
		                            <th>Subtitle</th>
		                            <th>Last added</th>
		                            <th>Action</th>
		                        </tr>
		                      </thead>
		                      <tbody>
		                        <tr v-for="item in movies">
		                        	<td>{{ item.movie_name }}</td>
		                        	<td>{{ item.release_year }}</td>
		                        	<td>
								  
										<div v-if="movie_settings.embed_id_status == 1" class="input-group-inline mb-5">
											<span class="input-group-prepend-inline">
												<button class="btn bg-purple btn-icon">ID</button>
											</span>
											<input type="text" class="form-control border-left-0" :value="'https://player.m2list.com/' + movie_settings.embed_slug + '/' + item.embed_id" onClick="this.select()" readonly>
										</div>

										<div v-if="item.imdb_id && movie_settings.imdb_id_status == 1" class="input-group-inline mb-5">
											<span class="input-group-prepend-inline">
												<button class="btn bg-purple btn-icon">IMDb</button>
											</span>
											<input type="text" :value="'https://player.m2list.com/' + movie_settings.embed_slug + '/' + item.imdb_id" class="form-control" onClick="this.select()" readonly>
										</div>

										<div v-if="item.tmdb_id && movie_settings.tmdb_id_status == 1" class="input-group-inline">
											<span class="input-group-prepend-inline">
												<button class="btn bg-purple btn-icon">TMDb</button>
											</span>
											<input type="text" :value="'https://player.m2list.com/' + movie_settings.embed_slug + '/' + item.tmdb_id" class="form-control" onClick="this.select()" readonly>
										</div>
		                        		
									</td>
		                        	<!-- Show subtitle -->
		                        		<td v-if="item.movie_subtitles != ''">
		                        			<label v-for="sub in item.movie_subtitles" class="btn bg-pink btn-icon ml-5">{{ sub.label_captions.label_name }}</label>
		                        		</td>

										<td v-else><label class="btn btn-default btn-icon">None</label></td>
									<!-- /Show subtitle -->

		                        	<td>{{ item.updated_at }}</td>
		                        	<td width="12%">
		                        		<button class="btn btn-info btn-icon" type="button" title="Edit" @click.prevent="onDetailMovie(item.id)"><i class="icon-pencil5"></i></button>
										<button class="btn btn-danger btn-icon" data-style="zoom-out" type="button" title="Delete" @click.prevent="onDeleteMovie(item.id)"><i class="icon-trash"></i></button>
		                        	</td>
		                        </tr>
		                      </tbody>
		                  </table>

		                  <div v-else class="pt-10">No record found</div>
		                </div>
						<!-- end:Table Responsive -->
						<pagination :pagination="pagination" @click.native="getDataPaging" :offset="4"></pagination>
					</div>

					<!-- begin::Modal Add Movie -->
					<div class="modal fade" id="modalAddMovie" tabindex="-1" role="dialog" aria-labelledby="ModalLabelAdd">
					    <div class="modal-dialog modal-lg">
					      <div class="modal-content">
					        <div class="modal-header bg-primary">
					          <h5 class="modal-title" id="ModalLabelAdd">Add new movie</h5>
					          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
					            <span aria-hidden="true">×</span>
					          </button>
					        </div>
					        <!--begin::Modal Body -->
					        <div class="modal-body">
					              <!--begin::Form-->
					              <form class="form-horizontal" id="formAddMovie">

					                  <div class="form-group">
					                      <label class="control-label col-sm-2">Movie name (*): </label>
					                      <div class="col-sm-10">
					                          <input type="text" class="form-control" name="movie_name">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2">Release Year (*): </label>
					                      <div class="col-sm-10">
					                          <input type="text" class="form-control" name="release_year">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2"><a href="https://www.imdb.com/" target="_blank" title="IMDb">IMDb</a> (*): </label>
					                      <div class="col-sm-10">
					                          <input type="text" class="form-control" name="imdb_id">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2"><a href="https://www.themoviedb.org/" target="_blank" title="The Movie Database (TMDb)">TMDb</a> (*): </label>
					                      <div class="col-sm-10">
					                          <input type="text" class="form-control" name="tmdb_id">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2">Subtitle (*): </label>
					                      <div class="col-sm-10">

												<!-- Begin::Add Sub -->
												<div class="row">
												    
												    <div class="col-sm-2"> 
														<select name="subLabel[]" class="form-control">
															<option v-for="label in movie_captions" :value="label.id">{{ label.label_name }}</option>
														</select>
												    </div>

												    <div class="col-sm-9"> 
												    	<input type="file" name="subFile[]" id="uploadSub" data-show-preview="false">
												    </div>

												    <div class="col-sm-1">
												    	<button type="button" @click.prevent="addSub" class="btn btn-success"><i class="icon-add"></i></button>
													</div>	
													
												</div>

									            <file-sub-add v-for="(sub, index) in subs"
									                 :key="index" :indexSub="indexSub" :movie_captions="movie_captions" @removeSub="removeSub(index)">
									            </file-sub-add>
												<!-- End::Add Sub -->

					                      </div>
					                  </div>
										
			                          <div class="form-group">
			                              <label class="control-label col-sm-2">Server (*): </label>
			                              <div class="col-sm-10">
												<div v-for="cate in movie_servers" class="form-group">
													<div  id="sv-block" class="pb-30">
													    <div class="col-sm-3"> 
													    	<input type="text" :value="cate.server_name" class="form-control" readonly="readonly">
													    	<input type="hidden" name="cate_id[]" :value="cate.id" class="form-control">
													    </div>

													    <div class="col-sm-9"> 
													    	<input type="text" name="link[]" class="form-control">
													    </div>
													</div>
												 </div>
			                              </div>
			                           </div>
										
								        <!--begin::Modal Footer -->
								        <div class="modal-footer p-0 pt-10">
								            <button class="btn btn-primary" data-style="zoom-out" type="submit" title="Add"><i class="icon-plus2"></i> Add</button>
								            <button class="btn btn-default" type="button" data-dismiss="modal" title="Close"><i class="icon-cross"></i> Close</button>
								        </div>
								        <!--end::Modal Footer -->

					              </form>
					              <!--begin::Form-->
					        </div>
					        <!--end::Modal Body -->
					      </div>
					    </div>
					</div>
					<!-- end::Modal Add Movie -->

					<!-- begin::Modal Edit Movie -->
					<div class="modal fade" id="modalEditMovie" tabindex="-1" role="dialog" aria-labelledby="ModalLabelMovieEdit">
					    <div class="modal-dialog modal-lg">
					      <div class="modal-content">
					        <div class="modal-header bg-info">
					          <h5 class="modal-title" id="ModalLabelMovieEdit">Edit movie</h5>
					          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
					            <span aria-hidden="true">×</span>
					          </button>
					        </div>
					        <!--begin::Modal Body -->
					        <div class="modal-body">
					              <!--begin::Form-->
					              <form class="form-horizontal" id="formEditMovie">
	
					                  <div class="form-group">
					                      <label class="control-label col-sm-2">Movie name: (*): </label>
					                      <div class="col-sm-10">
					                          <input type="text" class="form-control" name="movie_name" :value="movie.movie_name">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2">Release Year (*): </label>
					                      <div class="col-sm-10">
					                          <input type="text" class="form-control" name="release_year" :value="movie.release_year">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2"><a href="https://www.imdb.com/" target="_blank" title="IMDb">IMDb</a> (*): </label>
					                      <div class="col-sm-10">
					                          <input v-if="movie.imdb_id" type="text" class="form-control" name="imdb_id" :value="movie.imdb_id">
					                          <input v-else type="text" class="form-control" name="imdb_id">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2"><a href="https://www.themoviedb.org/" target="_blank" title="The Movie Database (TMDb)">TMDb</a> (*): </label>
					                      <div class="col-sm-10">
					                          <input v-if="movie.tmdb_id" type="text" class="form-control" name="tmdb_id" :value="movie.tmdb_id">
					                          <input v-else type="text" class="form-control" name="tmdb_id">
					                      </div>
					                  </div>

					                  <div class="form-group">
					                      <label class="control-label col-sm-2">Subtitle: (*): </label>
					                      <div class="col-sm-10">

												<!-- Begin::Add Sub Edit -->
												<div class="row mb-10">
												    
												    <div class="col-sm-2"> 
														<select name="subLabelEdit[]" class="form-control">
															<option v-for="label in movie_captions" :value="label.id">{{ label.label_name }}</option>
														</select>
												    </div>

												    <div class="col-sm-9"> 
												    	<input type="file" name="subFileEdit[]" id="uploadSubEdit" data-show-preview="false">
												    </div>

												    <div class="col-sm-1">
												    	<button type="button" @click.prevent="addSubEdit" class="btn btn-success"><i class="icon-add"></i></button>
													</div>	
													
												</div>
					                    
												<file-sub-edit :movie_subtitles="movie_subtitles"/>

									            <file-sub-add-edit v-for="(subedit, index) in subsedit"
									                 :key="index" :indexSubEdit="indexSubEdit" :movie_captions="movie_captions" @removeSubEdit="removeSubEdit(index)">
									            </file-sub-add-edit>
												<!-- End::Add Sub Edit -->
												
					                      </div>
					                  </div>


									  <!-- begin:server -->
								      <div class="form-group">
								          <label class="control-label col-sm-2">Server (*): </label>
								          <div class="col-sm-10">
											<div v-for="sv in mv_servers" class="form-group">
													
													<div id="sv-block" class="pb-30">
													    <div class="col-sm-3"> 
													    	<input type="text" :value="sv.server_name" class="form-control" readonly="readonly">
													    	<input type="hidden" name="server_id[]" :value="sv.id" class="form-control">
													    </div>

													    <div class="col-sm-9"> 
													    	<input type="text" name="link[]" class="form-control" :value="sv.link">
													    </div>
													</div>
											 </div>
		
											<div v-if="new_servers!=null" v-for="new_server in new_servers" class="form-group">
												<div  id="sv-block" class="pb-30">
												    <div class="col-sm-3"> 
												    	<input type="text" :value="new_server.server_name" class="form-control" readonly="readonly">
												    	<input type="hidden" name="cate_id_new_server[]" :value="new_server.id" class="form-control">
												    </div>

												    <div class="col-sm-9"> 
												    	<input type="text" name="link_new_server[]" class="form-control">
												    </div>
												</div>
										 	</div>

								          </div>
								      </div>
									  <!-- end::server -->

										<input type="hidden" name="id" :value="movie.id">

								        <!--begin::Modal Footer -->
								        <div class="modal-footer p-0 pt-10">
								            <button class="btn btn-info" data-style="zoom-out" type="submit" title="Save changes"><i class="icon-checkmark2"></i> Save changes</button>
								            <button class="btn btn-default" type="button" data-dismiss="modal" title="Close"><i class="icon-cross"></i> Close</button>
								        </div>
								        <!--end::Modal Footer -->
					              </form>
					              <!--begin::Form-->
					        </div>
					        <!--end::Modal Body -->
					      </div>
					    </div>
					</div>
					<!-- end::Modal Edit Movie -->

				</div>
				<!-- /simple panel -->

				<!-- Footer -->
				<app-footer/>
				<!-- /footer -->

			</div>
			<!-- /content area -->
		</div>
		<!-- /main content -->
</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')
import SubAdd from '../child/SubAdd'
import SubAddEdit from '../child/SubAddEdit'
import SubEdit from '../child/SubEdit'
export default {
  components: {'file-sub-add': SubAdd, 'file-sub-edit': SubEdit, 'file-sub-add-edit': SubAddEdit},
  name: 'Movies',
  data () {
    return {
      indexSub: 1,
      indexSubEdit: 1,
      subs: [],
      subsedit: [],
      movie: {},
      movie_subtitles: {},
      new_servers: {},
      mv_servers: {},
      searchData: {},
      server_category: {}
    }
  },
  computed: {
    movies () {
      return this.$store.getters.movies
    },
    movie_servers () {
      return this.$store.getters.movie_servers
    },
    movie_captions () {
      return this.$store.getters.movie_captions
    },
    movie_settings () {
      return this.$store.getters.movie_settings
    },
    pagination () {
      return this.$store.getters.pagination_movies
    }
  },
  mounted() {

  	let vm = this;

  	Ladda.bind('button[type=submit]')

	$("#uploadSub").fileinput({
	    theme: "explorer",
	    browseClass: "btn btn-primary",
		removeClass: "btn btn-danger",
	    showUpload: false,
	    overwriteInitial: false,
	    initialPreviewAsData: false,
	    allowedPreviewTypes: null,
	    allowedFileExtensions: ["srt", "vtt"]
	});

	$("#uploadSubEdit").fileinput({
	    theme: "explorer",
	    browseClass: "btn btn-primary",
		removeClass: "btn btn-danger",
	    showUpload: false,
	    overwriteInitial: false,
	    initialPreviewAsData: false,
	    allowedPreviewTypes: null,
	    allowedFileExtensions: ["srt", "vtt"]
	});

    //Form Search
    $('#formSearchDataMovie').on('submit',function (e) {
        e.preventDefault();
        vm.searchData = new FormData(this)
        vm.$store.dispatch('loadDataMovie', vm.searchData)
        Ladda.stopAll();
    });

    //Form Movie Embed ID
    $('#formMovieEmbedID').on('submit',function (e) {
        e.preventDefault();
		axios.post('setting/edit/movie/embed_id?token=' + token, new FormData(this))
		.then(function (response) {
		    Ladda.stopAll()
		    vm.$store.dispatch('loadDataMovie')
		})
		.catch(function (error) {
		    Ladda.stopAll()
		    vm.notify('error_add')
		});
    });

    //Form Movie IMDb ID
    $('#formMovieIMDbID').on('submit',function (e) {
        e.preventDefault();
		axios.post('setting/edit/movie/imdb_id?token=' + token, new FormData(this))
		.then(function (response) {
		    Ladda.stopAll()
		    vm.$store.dispatch('loadDataMovie')
		})
		.catch(function (error) {
		    Ladda.stopAll()
		    vm.notify('error_add')
		});
    });

    //Form Movie TMDb ID
    $('#formMovieTMDbID').on('submit',function (e) {
        e.preventDefault();
		axios.post('setting/edit/movie/tmdb_id?token=' + token, new FormData(this))
		.then(function (response) {
		    Ladda.stopAll()
		    vm.$store.dispatch('loadDataMovie')
		})
		.catch(function (error) {
		    Ladda.stopAll()
		    vm.notify('error_add')
		});
    });

    //formSearchSub
  //   $('#formSearchSub').on('submit',function (e) {
  //       e.preventDefault();
		// vm.$store.dispatch('loadSubMovie')
		// Ladda.stopAll()
  //   });

    $('#formAddMovie').on('submit', function (e) {
        e.preventDefault();
		axios.post('movie/add?token=' + token, new FormData(this))
		.then(function (response) {
		    $('#formAddMovie')[0].reset()
		    Ladda.stopAll()
		    vm.$store.dispatch('loadDataMovie')
		    $('#modalAddMovie').modal('hide')
		    vm.notify('success_add')
		})
		.catch(function (error) {
		    Ladda.stopAll()
		    $('#modalAddMovie').modal('hide')
		    vm.notify('error_add')
		});
    });

    $('#formEditMovie').on('submit', function (e) {
        e.preventDefault();
		axios.post('movie/edit?token=' + token, new FormData(this))
		.then(function (response) {
		    Ladda.stopAll()
		    vm.$store.dispatch('loadDataMovie')
		    $('#modalEditMovie').modal('hide')
		    vm.notify('success_edit')
		})
		.catch(function (error) {
		    Ladda.stopAll()
		    $('#modalEditMovie').modal('hide')
		    vm.notify('error_edit')
		});
    });

    return this.$store.dispatch('loadDataMovie')
  },
  methods:{
  	formMovieEmbedID(){
  		alert('hello')
  	},
    addSub(){
        this.subs.push({ sub: '' });
        this.indexSub += 1
    },
    removeSub(index){
        this.subs.splice(index, 1)
        this.indexSub -= 1
    },
    addSubEdit(){
        this.subsedit.push({ subedit: '' });
        this.indexSubEdit += 1
    },
    removeSubEdit(index){
        this.subsedit.splice(index, 1)
        this.indexSubEdit -= 1
    },
	getDataPaging(){
		return this.$store.dispatch('loadDataMovie')
	},
    onDetailMovie(id){
    	Object.assign(this.$data, this.$options.data())
    	let vm = this;
		axios.get('movie/edit/'+ id + '?token=' + token)
		.then(function (response) {
		    vm.movie = response.data.movie
		    vm.movie_subtitles = response.data.movie_subtitles
		    vm.mv_servers = response.data.movie_servers
		    vm.new_servers = response.data.new_servers
		    $('#modalEditMovie').modal('show')
		})
		.catch(function (error) {
		    $('#modalEditMovie').modal('hide')
		    vm.notify('error_edit')
		});
    },
    onDeleteMovie(id){
    	let vm = this;
		Swal.fire({
	            title: "Are you sure?",
	            text: "You will not be able to recover this Movie!",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonColor: '#FF7043',
	            confirmButtonText: "Yes, delete it!"
		    }).then((result) => {
				  if (result.value) {
					axios.post('movie/delete?token=' + token, {'id': id})
					.then(function (response) {
					    Ladda.stopAll()
					    vm.$store.dispatch('loadDataMovie')
					    $('#modalEditMovie').modal('hide')
					    vm.notify('success_delete')
					})
					.catch(function (error) {
					    Ladda.stopAll()
					    $('#modalEditMovie').modal('hide')
					    vm.notify('error_delete')
					});
				  }
				});
    }
    //
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/Movies.vue